import React from 'react'
import PropTypes from 'prop-types'
import Link from "next/link";
import DropdownUser from "./DropdownUser";
import Image from "next/image";
import { IoNotificationsOutline } from "react-icons/io5";
import { useAuth } from "@/contexts/AuthContext";

const BASE_OLD = "https://online.portoviejo.gob.ec";
const BUZON_URL = `${BASE_OLD}/Notificaciones/Buzon2.aspx`;

const Header = (props) => {
  const { user } = useAuth();

  const openBuzon = async () => {
    try {
      const r = await fetch(`/api/auth/online-link?to=${encodeURIComponent(BUZON_URL)}`, {
        cache: "no-store",
      });

      // Si no hay sesión, avisa (o redirige al login de tu app)
      if (r.status === 401) {
        // aquí puedes usar tu dialog/toast si tienes
        alert("Tu sesión expiró. Inicia sesión para ver el buzón.");
        window.location.href = "/auth/signin";
        return;
      }

      const data = await r.json();
      if (!r.ok || !data?.success || !data?.url) {
        throw new Error(data?.message || "No se pudo abrir el buzón.");
      }

      window.open(data.url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error(err);
      alert("No se pudo abrir el buzón en este momento.");
    }
  };

  return (
    <header className="sticky top-0 z-999 flex w-full bg-base-100 drop-shadow-1 dark:bg-dark-base-100 dark:drop-shadow-none">
      <div className="flex flex-grow items-center justify-between px-4 py-4 shadow-2 md:px-6 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          {/* <!-- Hamburger Toggle BTN --> */}
          <button
            aria-controls="sidebar"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className="z-99999 block rounded-sm border border-stroke bg-base-100 p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
          >
            <span className="relative block h-5.5 w-5.5 cursor-pointer">
              <span className="du-block absolute right-0 h-full w-full">
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-gray-400 ${!props.sidebarOpen && "!w-full delay-300"
                    }`}
                ></span>
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-gray-400 ${!props.sidebarOpen && "delay-400 !w-full"
                    }`}
                ></span>
                <span
                  className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-gray-400 ${!props.sidebarOpen && "!w-full delay-500"
                    }`}
                ></span>
              </span>
              <span className="absolute right-0 h-full w-full rotate-45">
                <span
                  className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-gray-400 ${!props.sidebarOpen && "!h-0 !delay-[0]"
                    }`}
                ></span>
                <span
                  className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-gray-400 ${!props.sidebarOpen && "!h-0 !delay-200"
                    }`}
                ></span>
              </span>
            </span>
          </button>
          {/* <!-- Hamburger Toggle BTN --> */}

          <Link className="block flex-shrink-0 lg:hidden" href="/">
            <Image
              width={32}
              height={32}
              src={"/images/logo/Marca L_7.png"}
              alt="Logo"
            />
          </Link>
        </div>

        <div className="hidden sm:block">
          <h1 className="ml-4 text-2xl font-bold text-primary">
            {process.env.NEXT_PUBLIC_APPNAME}
          </h1>
        </div>

        <div className="flex items-center gap-3 2xsm:gap-7">
          {user && (
            <button
              type="button"
              onClick={openBuzon}
              className="btn btn-ghost btn-circle"
              title="Buzón / Notificaciones"
            >
              <IoNotificationsOutline size={24} />
            </button>
          )}

          {/* <!-- User Area --> */}
          <DropdownUser />
          {/* <!-- User Area --> */}
        </div>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  setSidebarOpen: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
};
